import request from '@/utils/request'

const url='/applicant';
export function getMyPlanAppCfg(params) {
  return request({
    url: url + '/getMyPlanAppCfg',
    method:'get',
    params:params
  })
}
export function getPlanApplicant(params) {
  return request({
    url: url + '/getPlanApplicant',
    method:'get',
    params:params
  })
}


export function getPlanAppCfg(params) {
  return request({
    url: url + '/getPlanAppCfg',
    method:'get',
    params:params
  })
}

export function createApplicant(data) {
  return request({
    url:'/applicant/create',
    method:'post',
    data:data
  })
}
export function validateApplicant(data) {
  return request({
    url:'/applicant/validateApplicant',
    method:'post',
    data:data
  })
}

export function getPlanMyApplicant(params) {
  return request({
    url:'/applicant/getPlanMyApplicant',
    method:'get',
    params:params
  })
}


export function getMyApplicant(params) {
  return request({
    url:'/applicant/getMyApplicant',
    method:'get',
    params:params
  })
}
export function getPlanMyPositions(params) {
  return request({
    url:'/applicant/getPlanMyPositions',
    method:'get',
    params:params
  })
}


export function downPdf(params) {
  return request({
    url: '/applicant/pdfApplicant',
    method: 'get',
    params: params
  })
}

export function getPlanMyHire(params) {
  return request({
    url:'/applicant/getPlanMyHire',
    method:'get',
    params:params
  })
}

export function updateHire(id,data) {
  return request({
    url:'/applicant/updateHire/'+id,
    method:'post',
    data:data
  })
}


export function getHireattaCfg(params) {
  return request({
    url:'/hireatta/listAll',
    method:'get',
    params:params
  })
}

export function getApplicant(id) {
  return request({
    url:'/applicant/getApplicant'+id,
    method:'get',
  })
}

export function updateApplicant(id,data) {
  return request({
    url:'/applicant/updateApplicant/'+id,
    method:'post',
    data:data
  })
}

export function updateStatus(id,params) {
  return request({
    url:'/applicant/updateStatus/'+id,
    method:'post',
    params: params
  })
}

export function updateHireStatus(id,params) {
  return request({
    url:'/applicant/updateHireStatus/'+id,
    method:'post',
    params: params
  })
} 

export function getSginImg(params) {
  return request({
    url:'/applicant/getSginImg',
    method:'get',
    params: params
  })
}

export function getMySginImg(params) {
  return request({
    url:'/applicant/getMySginImg',
    method:'get',
    params: params
  })
}






// WEBPACK FOOTER //
// ./src/api/applicant.js